const basicCustomerChargeRate = {
  rateElementType: 'FixedPerMonth',
  name: 'Basic Service Charge',
  rateComponents: [
    {
      charge: -24.0,
      name: 'EV charging portion',
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
    },
  ],
};

const EnergyCharge = {
  name: 'Energy Charge',
  rateElementType: 'EnergyTimeOfUse',
  rateComponents: [
    {
      charge: 0.07576, // 7.576¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Energy Charge (All Months)',
    },
    {
      charge: 0.00019, // 0.019¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Merchant Function Charge per kWh',
    },
    {
      charge: 0.003024, // 0.3024¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'System Benefit Charge per kWh',
    },
    {
      charge: -0.00001, // -0.001¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Earnings Adjustment Mechanism per kWh',
    },
    {
      charge: -0.00009, //  -0.009¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Transmission Revenue Adjustment per kWh',
    },
    {
      charge: 0.06018, //  0.060180¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Electric Supply Charge per kWh)',
    },

    {
      charge: 0.00392, //  0.3920¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Value of Distributed Energy Resources per kWh',
    },
    {
      charge: -0.00421, //  -0.421¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Revenue Decoupling Mechanism per kWh',
    },

    {
      charge: 0.00741, //  0.741¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Clean Energy Standard Supply Charges per kWh',
    },
    {
      charge: 0.00021, //  0.0210¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Clean Energy Supply Delivery Charges per kWh',
    },

    {
      charge: 0.00087, //  0.087¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Arrears Management Program Recovery Surcharge per kWh',
    },

    {
      charge: 0.00036, //  0.036¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Electric Vehicle Make Ready Surcharge per kWh',
    },
  ],
};

const residentialRate = () => {
  return {
    name: 'Residential Service',
    title: 'National Grid SC1 with EV Charge Smart',
    rateElements: [basicCustomerChargeRate, EnergyCharge],
  };
};

export default residentialRate;
